<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword"
                        :placeholder="$t('keyword')" v-on:keydown.enter="load"></b-form-input>
          <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="type"
                       :options="actionOpts"></form-select>
          <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1"></time-range-picker>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-lg-2">{{ $t('time') }}</div>
          <div class="col-lg-8">{{ $t('content') }}</div>
          <div class="col-lg-2">{{ $t('createdBy') }}</div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-2">
            <span>{{ item.time | moment('DD/MM/YYYY HH:mm:ss') }}</span>
          </div>
          <div class="col-lg-8">
            <div class="c-sms-item__title">
              <span v-if="item.type === 'delete'" v-html="item.content"></span>
              <span v-else>
                <span class="text-gray-999">
                {{ $t(getOrderLogLabel(item)) }}:
              </span>
                <b>{{ item.productOrder ? '#' + item.productOrder.code : $t('unknown') }}</b>&nbsp;
              </span>
              <div class="c-sms-item__label" v-if="item && item.type === 'change'">
                <span class="badge badge-primary is-label">{{ getOrderStatusLabel(item.fromStatus) }}</span>
                &nbsp;<i class="fa fa-long-arrow-right"></i>&nbsp;
                <span class="badge badge-primary is-label">{{ getOrderStatusLabel(item.toStatus) }}</span>
              </div>
              <div class="c-sms-item__content active" v-if="item.content && item.type !== 'delete'">
                <span v-html="content(item.content)"></span>
              </div>
            </div>
          </div>
          <div class="col-lg-2">
            <span v-if="item.user">{{ item.user.name }} ({{ item.user.ext }})</span>
            <span v-else>{{ $t('unknown') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>
    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
  </div>
</template>

<script>
import List from "@/mixins/List";
import TimeRangePicker from "@/components/TimeRangePicker.vue";

export default {
  components: {TimeRangePicker},
  props: ['client'],
  mixins: [List],
  data() {
    return {
      service: 'order-log',
      autoLoad: true,
      defaultFilterFormModel: {
        type: null,
        client: this.client._id,
      },
      actionOpts: [
        {value: null, text: this.$t('chooseAction')},
        {value: 'create', text: this.$t('create')},
        {value: 'update', text: this.$t('update')},
        {value: 'change', text: this.$t('updateStatus')},
        {value: 'delete', text: this.$t('delete')},
      ],
      orderStatuses: [
        {value: 'new', text: this.$t('newStatus')},
        {value: 'processing', text: this.$t('processing')},
        {value: 'waitForConfirm', text: this.$t('waitForConfirm')},
        {value: 'confirming', text: this.$t('confirming')},
        {value: 'confirmed', text: this.$t('confirmed')},
        {value: 'soldOut', text: this.$t('soldOut')},
        {value: 'changeWarehouse', text: this.$t('changeWarehouse')},
        {value: 'packing', text: this.$t('packing')},
        {value: 'packed', text: this.$t('packed')},
        {value: 'pickup', text: this.$t('pickup')},
        {value: 'shipping', text: this.$t('shippingStatus')},
        {value: 'success', text: this.$t('success')},
        {value: 'failure', text: this.$t('failure')},
        {value: 'refund', text: this.$t('refund')},
        {value: 'refunding', text: this.$t('refunding')},
        {value: 'refundConfirmed', text: this.$t('refundConfirmed')},
        {value: 'refunded', text: this.$t('refunded')},
        {value: 'cancel', text: this.$t('cancel')},
        {value: 'customerCancel', text: this.$t('customerCancel')},
        {value: 'systemCancel', text: this.$t('systemCancel')},
        {value: 'carrierCancel', text: this.$t('carrierCancel')},
      ],
    }
  },
  methods: {
    getOrderLogLabel(item) {
      if (item) {
        if (item.type === 'create') {
          return 'createNewOrder'
        }
        if (item.type === 'update') {
          return 'updateOrder'
        }
        if (item.type === 'change') {
          return 'changeStatusOrder'
        }
      }
      return null;
    },
    getOrderStatusLabel(status) {
      if (this.orderStatuses.find(s => s.value === status)) {
        return this.orderStatuses.find(s => s.value === status).text
      }
      return status;
    },
    content(string) {
      return string.replace(/\n/g, '<br/>');
    },
  },
  i18n: {
    messages: {
      en: {
        delete: "Delete",
        updateStatus: "Update status",
        chooseAction: "Choose action",
        content: "Content",
        createdBy: 'Created by',
        changeStatusOrder: "Update order status",
        updateOrder: "Update order",
        createNewOrder: "Create new order",
        refund: "Refund",
        processing: "Processing",
        newStatus: "New status",
        failure: "Failure",
        confirming: "Confirming",
        changeWarehouse: "Warehouse transfer",
        refunding: "Refunding",
      },
      vi: {
        delete: "Xoá",
        updateStatus: "Cập nhật trạng thái",
        chooseAction: "Chọn hành động",
        content: "Nội dung",
        createdBy: 'Tạo bởi',
        changeStatusOrder: "Cập nhật trạng thái đơn hàng",
        updateOrder: "Cập nhật đơn hàng",
        createNewOrder: "Tạo mới đơn hàng",
        refund: "Hoàn hàng",
        processing: "Đang xử lý",
        newStatus: "Mới",
        failure: "Thất bại",
        confirming: "Đang xác nhận",
        changeWarehouse: "Chuyển kho",
        refunding: "Đang chuyển hoàn",
      },
    },
  },
}
</script>